export default "__VITE_ASSET___L4B85Kg7_78CgH4If65XA__"